import React from 'react'

function AboutMe(props) {
  return (
    <div className="about-me-container div-margin">
      <div className="about-me-info">
        <h2 >About Me</h2>
        <p> A digitally enthusiastic individual with a strong love for Software Engineering and Cyber Security. </p>
        <p> Passionate about providing high quality, cutting edge ideas to any project present. </p>
        <p id="Experience">Natural flair for problem solving in order to overcome challenges that are presented. </p>
        <p> Currently looking to gain experience in the technology sector to further improve my skills. </p>
      </div>
    </div>
  )
}

export default AboutMe
